/**
 * 丹方：草药与灵气的去处。
 *
 * 闭环上的位置：
 *   采集（forage）出草药 —— 原先草药只会堆在包袱里发霉，现在能炼；
 *   灵气有了第四个出口 —— 御气催熟、清心汤之外，还能起火炼丹；
 *   修行有了第二个门槛 —— 修行不到「感气」，丹火根本点不着。
 *
 * 丹不进包袱：炼成即服（跟灶上一个道理，做出来就趁热）。
 *   need      要的料（走 Repo.countItem / takeItem）
 *   qi        炼这一味要花多少灵气
 *   minRealm  修行要到哪一层才点得着丹火（data/inspire.js 的 REALMS.level）
 *   cert      还得手上有一张灶上的照（火候）——讲究的丹不是谁都炼得成
 *   heat      难易（越大越容易失手，见 systems/inspire.js 的 pillOdds）
 */
export const PILLS = [
  {
    id: 'restore',
    name: '回气丹',
    need: { herb: 2 },
    qi: 8,
    minRealm: 1,
    cert: null,
    heat: 8,
    effect: { energy: 18, fatigue: -12 },
    text: '丹成，趁热服下：身上松快了些，人也精神。',
    failText: '一炉药糊了，只闻见一股焦味。',
  },
  {
    id: 'warm',
    name: '温养丹',
    need: { herb: 3, veg: 1 },
    qi: 15,
    minRealm: 1,
    cert: null,
    heat: 16,
    effect: { satiety: 25, mood: 6 },
    text: '丹入喉，一路暖到胃里，倒像是吃了顿安稳饭。',
    failText: '火候没拿住，一炉药成了炭。',
  },
  {
    id: 'openVein',
    name: '通脉丹',
    need: { herb: 5, jade: 1 },
    qi: 30,
    minRealm: 2,
    cert: 'cook_2',
    heat: 26,
    effect: { mood: 8, qi: 10 },
    perk: 'clearHeartStrong',     // 比一碗清心汤更管用：这一整天念头格外聚拢
    text: '丹气顺脉而行，心里忽然清亮——今天想事情格外顺。',
    failText: '丹没凝住，一炉灵气散了个干净。',
  },
];

/** 按 id 找丹方 */
export function getPill(id) {
  return PILLS.find((p) => p.id === id) || null;
}
